import React from 'react';
import VehicleEntityGridPage from './VehicleEntityGridPage';
import { VEHICLE_FUEL_LOGS } from './vehicleEntityConfigs';

const VehicleFuelLogs = () => <VehicleEntityGridPage config={VEHICLE_FUEL_LOGS} />;

export default VehicleFuelLogs;
